import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import PrivacyPage from './PrivacyPage';
import './PrivacyPage.less';

export const prefix = 'bm-p-privacy';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: PrivacyPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
